import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';
import Header from './Header';
import Tabs from './Tabs';
import Footer from './Footer';

const Layout: React.FC = () => {
  const location = useLocation();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <CssBaseline />
      <Header />
      <Tabs selectedTab={location.pathname} onTabChange={() => {}} />
      <Box
        sx={{
          marginTop: '64px',
          marginLeft: '200px',
          backgroundColor: 'white',
          flex: 1,
          overflow: 'auto',
        }}
      >
        <Outlet />
      </Box>
      <Footer />

    </Box>
  );
};

export default Layout;
